
// URL for OMDB
export const URL = "https://www.omdbapi.com/"

// API Key for OMDB
export const KEY = "f52e54eb";
